import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordFeature } from "@/features/auth/ForgotPasswordFeature";

function ForgotPasswordPage() {
  return <ForgotPasswordFeature />;
}

export const Route = createFileRoute("/(auth)/forgot-password")({
  component: ForgotPasswordPage,
  staticData: { authorize: false },
});
